import { GENERATE_OPTIMAL_TIME } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function generateOptimalTimeReducer(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case GENERATE_OPTIMAL_TIME:
     
      // const parsedData = JSON.parse(action.payload.data)
     console.log("THE OPTIMAL TIME GENERATION IN REDUCER", (action.payload.data) )
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
